import React, { useState } from "react";

import PasswordInput from "./PasswordInput/PasswordInput.component";
import { KeyNavigation } from "../KeyNavigation/KeyNavigation.component";

import "./GenerateKey.component.scss";

const GenerateKey = () => {
    const [counterKey, setCounterKey] = useState(null);

    return (
        <div className="configuration-key">
            <KeyNavigation></KeyNavigation>

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>Key Generator</h1>
                        <h2>
                            Insert your hall password and your configurations
                            editing key will be presented.
                        </h2>
                        <PasswordInput
                            onGetKey={counter => setCounterKey(counter)}
                            counterKey={counterKey}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenerateKey;
